module.exports = {"211003004":"庆阳街道","211003008":"东京陵街道","211003009":"新城街道","211003101":"小屯镇","211003102":"罗大台镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211003.json
// module id = 524
// module chunks = 0